import {
  generateBindings,
  observableValue,
  useSharedState,
  view,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-textarea';
import { TextAreaCharCounter, TextFieldType } from '@material/mwc-textarea';
import { html } from 'lit';

export const [Textarea] = view('esui-mwc-textarea', {
  Props: class {
    label = '';
    name = '';
    rows?: number = undefined;
    cols?: number = undefined;
    type: TextFieldType = 'text';
    value = observableValue('');
    isValid = observableValue(false);
    endAligned = false;
    placeholder?: string = undefined;
    icon?: string = undefined;
    iconTrailing?: string = undefined;
    disabled = false;
    required = false;
    fullWidth = false;
    charCounter: boolean | TextAreaCharCounter = false;
    outlined = false;
    helper?: string = undefined;
    helperPersistent = false;
    maxLength?: number = undefined;
    validationMessage?: string = undefined;
    validateOnInitialRender = false;
    validityTransform:
      | ((
          value: string,
          nativeValidity: ValidityState
        ) => Partial<ValidityState>)
      | null = null;

    onChange?: (_: string, isValid: boolean) => void = undefined;
  },

  mapBuilder:
    TextareaBuilder =>
    (label: string, value = observableValue('')) =>
      TextareaBuilder().label(label).value(value),

  template(props) {
    const content = useSharedState(props.value);
    const isValid = useSharedState(props.isValid);

    const computedProps = generateBindings(props, [
      'value',
      'isValid',
      'validityTransform',
    ]);

    function handleChange(e: { target: HTMLInputElement }) {
      content.value = e.target.value;
      isValid.value = e.target.checkValidity();
    }

    const style = props.fullWidth
      ? html`
          <style>
            mwc-textarea {
              width: 100%;
            }
          </style>
        `
      : html``;

    return html`
      ${style}
      <mwc-textarea
        ${spread(computedProps)}
        .value="${content.value}"
        .validityTransform="${props.validityTransform}"
        @input="${handleChange}"
      ></mwc-textarea>
    `;
  },
});
